<template>
  <CRow>
    <CCol col="12" lg="5">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Προσθήκη επιθεωρητή
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Ονοματεπώνυμο" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Ονοματεπώνυμο" v-model="name" horizontal></CInput>
              <CTextarea id="activity" addLabelClasses="requiredLabel" label="Δραστηριότητα" placeholder="Δραστηριότητα" v-model="activity" horizontal></CTextarea>
              <CInput type="text" addLabelClasses="requiredLabel" label="ΑΦΜ" id="afm" placeholder="ΑΦΜ" v-model="afm"></CInput>
              <label>Πρότυπο ISO</label>
              <multiselect 
                v-model="iso"
                id="iso"
                :options="isoOptions" 
                :disabled="disabled"
                label="label" 
                track-by="label"
                @input="refreshIso()"
                class="mb-3"
                multiple
              ></multiselect>
              <CTextarea id="comments" label="Σχόλια" placeholder="Σχόλια" v-model="comments" horizontal></CTextarea>
              <CCol tag="label" sm="3" class="col-form-label p-0 mb-4 requiredLabel">
                Ενεργός
              </CCol>
              <CSwitch :checked.sync="active" id="active" shape="pill" color="success" class="pt-2" v-model="active" /><br>

            <CButton color="primary" @click="storeInspector()">Δημιουργία</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol col="12" lg="7">
      <CCard>
        <CCardHeader>
          <strong>EA / NACE</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              EA / NACE
            </template>
              <div class="form-row">
                <CCol sm="12" class="mb-2 requiredLabel">
                  Πρότυπα:
                </CCol>
                <template v-for="item in inspectors">
                  <CCol sm="3" class="m-0" :key="`iso-${item.id}`">
                    <multiselect 
                      id="selectedIso"
                      v-model="item.selectedIso" 
                      :options="selectedIsoOptions"
                      :disabled="isoDisabled"
                      label="label"
                      @input="refreshSubcategory($event,item)"
                      track-by="label">
                    </multiselect>
                  </CCol>
                  <CCol sm="2" class="m-0" :key="`ea-${item.id}`">
                    <multiselect 
                      v-model="item.ea" 
                      id="ea" 
                      :options="item.eaOptions"
                      :disabled="item.subDisabled"
                      label="label"
                      track-by="label">
                    </multiselect>
                  </CCol>
                  <CCol sm="3" class="m-0" :key="`role-${item.id}`">
                  <multiselect 
                    id="role"
                    v-model="item.role"
                    :options="roles" 
                    :disabled="item.roleDisabled"
                    label="label" 
                    track-by="label"
                  ></multiselect>
                  </CCol>
                  <CCol sm="3" class="m-auto" :key="`active_since-${item.id}`">
                    <CInput
                      type="date"
                      v-model="item.active_since"
                      :disabled="item.dateDisabled"
                      horizontal
                    />
                  </CCol>
                  <CCol sm="1" :key="`activeEA-${item.id}`">
                    <CSwitch :checked.sync="item.activeEA" id="activeEA" shape="pill" color="success" class="pt-2" v-model="item.activeEA" /><br>
                  </CCol>
                </template>
                <CCol sm="12">
                  <CButton v-show="showAdd" color="primary" @click="addRow()">Προσθήκη</CButton>
                </CCol>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { DatePicker } from 'v-calendar'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'

export default {
  name: 'CreateInspector',
  props: {
    caption: {
      type: String,
      default: 'Create Inspector'
    },
  },
  components: {
    'v-date-picker': DatePicker,
    Multiselect,
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  data: () => {
    return {
        name: '',
        afm: '',
        iso: '',
        selectedIso: '',
        isoOptions: [],
        selectedIsoOptions: [],
        role: '',
        ea: '',
        roleOptions: [],
        active: true,
        active_since: '',
        activeEA: true,
        eaOptions: [],
        showAdd: true,
        isoDisabled: true,
        subDisabled: true,
        roleDisabled: true,
        dateDisabled: true,
        disabled: false,
        activity: '',
        comments: '',
        showMessage: false,
        inspectors: [{id: 0, iso: '', selectedIso: '', ea: '', role: '', active_since: '', activeEA: true, subDisabled: true, roleDisabled: true, dateDisabled: true, eaOptions: []}],
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        alertIsShown: false,
        showDismissibleAlert: false,
        roles: []
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/inspectors'})
    },
    addRow () {
      let self = this;
      if (!self.inspectors.length) {
        var id = 0;
      } else {
        var id = Math.max.apply(Math,self.inspectors.map(function(o){return o.id;})) + 1;
      }
      self.inspectors.push({ id, iso: '', selectedIso: '', ea: '', role: '', active_since: '', activeEA: true, subDisabled: true, roleDisabled: true, dateDisabled: true, eaOptions: []});
    },
    storeInspector() {
        let self = this;
        let services = self.iso.map((item) => {return item.value;});
        let inspectors = self.inspectors.filter((item) => item.ea && item.active_since);

        inspectors = inspectors.map((item) => {
          return {
            id: item.ea.value,
            selectedIso: item.selectedIso.value,
            role: item.role.value,
            active_since: item.active_since,
            activeEA: item.activeEA
          }
        });

        axios.post('/api/inspectors?token=' + localStorage.getItem("api_token"),
        {
          name: self.name,
          afm: self.afm,
          activity: self.activity,
          services: services,
          comments: self.comments,
          active: self.active,
          // inspectors: JSON.stringify(inspectors),
          inspectors: inspectors,
        })
        .then(function (response) {
            self.message = 'Επιτυχής καταχώρηση επιθεωρητή.';
            self.showAlert();
        }).catch(function (error) {
            if (error.response.data.message == 'The given data was invalid.') {
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            } else {
              console.log(error.response.data.message);
              console.log(error);
              // self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    refreshSubcategory(selectedOption, item) {
      let self = this;
      item.subDisabled = true;
      item.roleDisabled = true;
      item.dateDisabled = true;

      if (item.selectedIso) {
        axios.get('/api/services/get_subcategories/' + selectedOption.value + '?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          item.eaOptions = response.data.service_subcategories.map((item) => {
            return {
              value: item.id,
              label: item.name
            }
          });
          item.ea = item.eaOptions[0];
          item.subDisabled = false;

          item.role = self.roles[0];
          item.roleDisabled = false;
          item.dateDisabled = false;
        }).catch(function (error) {
          console.log(error);
          // self.$router.push({ path: '/login' });
        });

        item.active_since = moment(new Date()).format('YYYY-MM-DD');
      } else {
        item.ea = [];
        item.role = [];
        item.active_since = '';
      }
    },
    refreshIso() {
      let self = this;
      self.isoDisabled = true;

      if (self.iso.length != 0) {
        self.selectedIsoOptions = self.iso.map((item) => {
          return {
            value: item.value,
            label: item.label
          }
        });
        self.selectedIso = [];
        self.isoDisabled = false;
      } else {
        self.isoDisabled = true;
      }
    }
  },
  mounted: function(){
    let self = this;
      axios.get('/api/inspectors/create?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.isoOptions = response.data.services.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        });

        self.iso = [];

        self.roles = response.data.roles.map((item) => {
          return {
            value: item.id,
            label: item.role
          }
        })
      }).catch(function (error) {
        console.log(error);
        // self.$router.push({ path: '/login' });
      });
    }
}

</script>